import { countries } from '#common/countries';

const shopSettingsCountries = Object.fromEntries(countries.map(c => [ c.code, c.de ]));

export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'Sprecherportal'
        },
        mediums: {
            commercials: 'Werbung',
            'info-videos': 'Info-Videos',
            'social-media': 'Soziale Medien',
            'e-learning': 'E-Learning',
            public: 'Öffentlich'
        },
        buttons: {
            cancel: 'Abbrechen',
            back: 'Zurück',
            submit: 'Absenden'
        },
        errors: {
            somethingWentWrong: 'Etwas ist schiefgelaufen!'
        }
    },
    navigation: {
        title: 'CrispyVoice',
        subTitle: 'Sprecherportal',
        home: 'Dashboard',
        'clone-settings': 'Klon-Einstellungen',
        'shop-settings': 'Shop-Einstellungen',
        buyers: 'Käufer',
        sales: 'Verkäufe',
        voices: 'Meine Stimmen',
        'speaker-settings': 'Sprecher-Einstellungen',
        affiliate: 'CrispyAffiliate',
        account: 'Account',
        logout: 'Ausloggen'
    },
    login: {
        meta: {
            title: 'Login',
            subTitle: 'CrispyVoice Sprecherportal'
        },
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        'remember-me': 'Eingeloggt bleiben',
        login: 'Einloggen',
        signIn: 'Anmelden',
        forgotPassword: 'Passwort vergessen?',
        createAnAccount: 'Jetzt registrieren',
        resetPassword: 'Passwort zurücksetzen',
        backToLogin: 'Zurück zur Anmeldung',
        checkYourEmail: 'Überprüfe deine E-Mails',
        emailVerificationCodeSent: 'Wir haben dir einen Code zur Bestätigung deiner E-Mail-Adresse gesendet.',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen',
        check2faApp: 'Überprüfen Sie Ihre 2FA-App',
        enter2faCode: 'Bitte geben Sie Ihren 2FA-Code ein, um Ihre Identität zu bestätigen.'
    },
    auth: {
        titles: {
            forgotPassword: 'Passwort vergessen?',
            login: 'Anmelden',
            register: 'Registrieren',
            resetPassword: 'Passwort zurücksetzen',
            verifyCode: 'Code eingeben'
        }
    },
    welcome: {
        welcome: 'Willkommen bei CrispyVoice!',
        greeting: 'Schön, dich bei uns zu haben, {{user_name}}!',
        steps: {
            explanation:
                'Bevor du deinen Klon nutzen kannst, müssen wir dich bitten die folgenden Schritte durchzuführen:',
            record: 'Nimm {{hours}} Stunden deiner Stimme in Studio-Qualiät auf',
            'upload-and-confirm':
                'Lade deine Aufnahmen in den <0>$t(navigation:clone-settings)</0> hoch und bestätige sie dann',
            'sit-back':
                'Lehn dich zurück und warte, während wir deine CrispyVoice erstellen. Dies wird ein paar Tage dauern'
        },
        core: {
            explanation: 'Verbinde zunächst deinen ElevenLabs-Account, um loszulegen:',
            'set-api-key': 'Trage deinen ElevenLabs-API-Schlüssel in den <0>$t(navigation:clone-settings)</0> ein'
        }
    },
    dashboard: {},
    'creating-clone': {
        heading: 'Klon wird erstellt...',
        subHeading:
            'Wir erstellen gerade deinen Klon. Das wird ein paar Tage dauern, bitte warte solange. Wir werden dich informieren, sobald dein Klon einsatzbereit ist.',
        'setup-shop':
            'Du kannst in der Zwischenzeit <0>deinen Shop</0> einrichten, damit du deine Stimme direkt nach Fertigstellung monetarisieren kannst.',
        core: {
            heading: 'Stimme einrichten',
            subHeading: 'Dein ElevenLabs-Account ist verbunden. Erstelle und konfiguriere jetzt deine erste Stimme.',
            'create-voice': 'Gehe zu <0>$t(navigation:voices)</0>, um deine Stimme zu erstellen und zu konfigurieren.'
        }
    },
    account: {
        heading: 'Account',
        name: 'Name',
        'name-change-successful': 'Name erfolgreich geändert!',
        language: 'Anzeigesprache',
        save: 'Speichern',
        email: 'E-Mail-Adresse',
        'change-email': 'E-Mail ändern',
        'new-email': 'Neue E-Mail-Adresse',
        'email-change-successful': 'E-Mail-Adresse erfolgreich geändert!',
        password: 'Passwort',
        'change-password': 'Passwort ändern',
        'current-password': 'Aktuelles Passwort',
        'new-password': 'Neues Passwort',
        'repeat-new-password': 'Neues Passwort bestätigen',
        'password-change-successful': 'Passwort erfolgreich geändert!',
        validation: {
            name: {
                required: 'Bitte gib einen Namen ein'
            },
            email: {
                invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
                same: 'Die neue E-Mail-Adresse ist identisch mit der aktuellen',
                taken: 'Diese E-Mail-Adresse wird bereits verwendet'
            },
            password: {
                currentRequired: 'Aktuelles Passwort ist erforderlich',
                repeatRequired: 'Bitte neues Passwort wiederholen',
                mismatch: 'Passwörter stimmen nicht überein',
                currentInvalid: 'Aktuelles Passwort ist falsch'
            }
        },
        invoices: 'Rechnungen',
        'invoice-date': 'Datum',
        'invoice-amount': 'Betrag',
        'invoice-status': 'Status',
        'invoice-link': 'Rechnung',
        'invoice-view': 'Ansehen',
        subscription: 'Abonnement',
        'subscription-status': 'Status',
        'subscription-duration': 'Abrechnungszyklus',
        'subscription-duration-monthly': 'Monatlich',
        'subscription-duration-yearly': 'Jährlich',
        'subscription-renews-on': 'Verlängert sich am {{date}}',
        'subscription-minimum-contract-until': 'Mindestvertragslaufzeit bis {{date}}',
        'subscription-cancels-on': 'Kündigung zum Ende der Abrechnungsperiode am {{date}}',
        'subscription-cancel': 'Abonnement kündigen',
        'subscription-cancel-confirm-title': 'Abonnement kündigen?',
        'subscription-cancel-confirm-body':
            'Möchtest du dein Abonnement wirklich kündigen? Bitte überprüfe die folgenden Details, bevor du fortfährst.',
        'subscription-cancel-effective-date': 'Dein Abonnement bleibt bis zum {{date}} aktiv.',
        'subscription-cancel-detail-access':
            'Du behältst vollen Zugang bis zum Ende deiner aktuellen Abrechnungsperiode.',
        'subscription-cancel-detail-reactivate': 'Du kannst dein Abonnement jederzeit vor Ablauf reaktivieren.',
        'subscription-cancel-confirm-button': 'Ja, Abonnement kündigen',
        'subscription-cancel-dismiss': 'Nein, Abonnement beibehalten',
        'subscription-cancelSuccessful':
            'Dein Abonnement wurde zum Ende der aktuellen Abrechnungsperiode zur Kündigung vorgemerkt.',
        'subscription-reactivate': 'Abonnement reaktivieren',
        'subscription-reactivateSuccessful': 'Dein Abonnement wurde erfolgreich reaktiviert.',
        'stripe-connect-heading': 'Auszahlungen',
        'stripe-connect-active': 'Deine Auszahlungen sind aktiv.',
        'stripe-connect-pending':
            'Dein Auszahlungskonto wurde erstellt, aber die Einrichtung ist noch nicht abgeschlossen.',
        'stripe-connect-not-connected': 'Richte Auszahlungen ein, um deine Einnahmen aus Audioverkäufen zu erhalten.',
        'stripe-connect-manage': 'Auszahlungen verwalten',
        'stripe-connect-setup': 'Auszahlungen einrichten',
        'stripe-connect-page-title': 'Stripe Connect',
        'stripe-connect-page-description':
            'Wir nutzen Stripe, um dir deine Auszahlungen zu senden, wenn Käufer dein Audio erwerben.',
        'stripe-connect-status': 'Status',
        'stripe-connect-payouts': 'Auszahlungen',
        'stripe-connect-payouts-enabled': 'Aktiv',
        'stripe-connect-payouts-pending': 'Einrichtung ausstehend',
        'stripe-connect-active-since': 'Aktiv seit:',
        'stripe-connect-deauthorized-on': 'Deautorisiert am:',
        'stripe-connect-no-account': 'Kein Stripe-Konto verbunden.',
        'stripe-connect-product-description': 'KI-generierte Audioinhalte über CrispyVoice',
        'stripe-connect-setup-title': 'Auszahlungen einrichten',
        'stripe-connect-setup-description':
            'Für deine Auszahlungen erstellen wir ein eigenes Stripe-Konto für deine CrispyVoice-Einnahmen. Stripe führt dich durch einen kurzen Einrichtungsprozess.',
        'stripe-connect-setup-button': 'Auszahlungskonto erstellen',
        'stripe-connect-setup-info':
            'Wir erstellen ein separates Stripe-Konto ausschließlich für deine CrispyVoice-Auszahlungen. Das schützt deine Privatsphäre — die Verknüpfung eines bestehenden Stripe-Kontos würde uns vollen Zugriff auf all deine Kunden, Transaktionen und Kontodaten gewähren.',
        'stripe-connect-redirecting': 'Dein Auszahlungskonto wird erstellt und du wirst zu Stripe weitergeleitet…',
        'stripe-connect-complete-title': 'Einrichtung abschließen',
        'stripe-connect-complete-description':
            'Dein Auszahlungskonto wurde erstellt, aber die Einrichtung ist noch nicht abgeschlossen. Mach dort weiter, wo du aufgehört hast, um Auszahlungen zu erhalten.',
        'stripe-connect-complete-button': 'Einrichtung fortsetzen',
        'stripe-connect-link-expired': 'Dein Onboarding-Link ist abgelaufen. Klicke unten für einen neuen.',
        'stripe-connect-connected-title': 'Auszahlungen aktiv',
        'stripe-connect-connected-description':
            'Alles bereit — deine Auszahlungen sind aktiv. Du kannst deine Auszahlungsdetails im Stripe Dashboard verwalten.',
        'stripe-connect-open-dashboard': 'Stripe Dashboard öffnen',
        'stripe-connect-disconnect': 'Trennen',
        'stripe-connect-disconnect-title': 'Stripe-Konto trennen?',
        'stripe-connect-disconnect-body':
            'Bist du sicher, dass du dein Stripe-Konto trennen möchtest? Du erhältst dann keine direkten Auszahlungen mehr für Audioveräufe.',
        'stripe-connect-disconnect-confirm': 'Ja, trennen',
        'stripe-connect-disconnect-cancel': 'Nein, verbunden lassen',
        'stripe-connect-success': 'Dein Stripe-Konto wurde erfolgreich verbunden!',
        'stripe-connect-error-exchange-failed': 'Verbindung mit Stripe fehlgeschlagen. Bitte versuche es erneut.',
        'stripe-connect-error-no-account-id': 'Keine Stripe-Konto-ID erhalten. Bitte versuche es erneut.',
        'stripe-connect-error-no-express-account':
            'Kein Express-Konto gefunden. Bitte starte den Onboarding-Prozess erneut.',
        'stripe-connect-reconnect-title': 'Konto erneut verbinden',
        'stripe-connect-reconnect-description':
            'Dein Express-Konto existiert noch bei Stripe. Du kannst es erneut verbinden, ohne deine Daten neu einzugeben.',
        'stripe-connect-reconnect-button': 'Stripe Express erneut verbinden',
        'stripe-connect-disconnected': 'Getrennt'
    },
    'clone-settings': {
        heading: '$t(navigation:clone-settings)',
        'already-confirmed':
            'Du hast deine hochgeladenen Aufnahmen bereits am {{when, datetime}} bestätigt. Wir arbeiten gerade an der Erstellung deines Klons.',
        'please-wait': 'Dies wird ein paar Tage dauern, bitte warte solange...',
        instructions:
            'Lade {{hours}} Stunden deiner Stimme hoch. Bestätige die hochgeladenen Aufnahmen um die Klon-Erstellung zu starten.',
        explanation:
            'Du kannst das Hochladen einer Datei jederzeit pausieren, entweder durch Klick auf den entsprechenden Button oder indem du zu einer anderen Seite wechselst oder den Browser schließt. Um das Hochladen dieser Datei dann fortzusetzen, wähle sie wieder über "$t(recordings.select-file)" aus.',
        dialogs: {
            confirm: {
                title: 'Aufnahmen bestätigen?',
                body:
                    'Bist du sicher, dass du deine Aufnahmen bestätigen willst? Dies wird den Erstellungsprozess deines Klons starten.',
                button: 'Aufnahmen bestätigen'
            },
            delete: {
                title: 'Aufnahme löschen?',
                body: 'Willst du diese Aufnahme wirklich löschen?',
                button: 'Ja, löschen'
            }
        },
        recordings: {
            filename: 'Dateiname',
            'total-size': 'Gesamtgröße',
            'uploaded-size': 'Bereits hochgeladen',
            size: 'Größe',
            progress: 'Fortschritt',
            status: {
                title: 'Status',
                finished: 'Fertig',
                uploading: 'Lädt hoch',
                paused: 'Pausiert'
            },
            actions: {
                title: 'Aktionen',
                delete: 'Löschen',
                pause: 'Pause',
                resume: 'Fortfahren'
            },
            'select-file': 'Datei auswählen',
            confirm: 'Bestätigen & Klon-Erstellung starten'
        },
        errors: {
            'total-size': 'Maximale Gesamtgröße {{size}} überschritten.',
            'file-size': 'Datei ist zu groß (über {{size}}).',
            'already-uploaded': 'Diese Datei wurde bereits vollständig hochgeladen.'
        },
        core: {
            'section-title': 'ElevenLabs API-Schlüssel',
            'section-description':
                'Gib deinen ElevenLabs API-Schlüssel ein, um dein Konto zu verbinden. Du kannst ihn jederzeit ändern.',
            'api-key-placeholder': 'ElevenLabs API-Schlüssel',
            'api-key-required': 'Bitte gib deinen API-Schlüssel ein.',
            'current-key': 'Aktueller API-Schlüssel: {{key}}',
            'save-successful': 'API-Schlüssel erfolgreich gespeichert.',
            save: 'API-Schlüssel speichern',
            'form-dirty': 'Du hast ungespeicherte Änderungen.'
        },
        'audio-editing': {
            heading: 'Professionelle Audiobearbeitung',
            description:
                'Willst du die bestmögliche Klangqualität für deinen Klon? Lass CrispyVoice deine Aufnahmen professionell bearbeiten (Mix & Master). Ohne diesen Service können wir die bestmögliche Klangqualität für deine Klonstimme nicht garantieren.',
            cta: 'Audiobearbeitung buchen'
        }
    },
    'shop-settings': {
        heading: 'Shop-Einstellungen',
        subheading:
            'Konfiguriere die Details Deines persönlichen Shops, in dem Deine Kund:innen Deine Stimme kaufen können.',
        'voice-heading': 'Stimm-Einstellungen',
        'voice-subheading': 'Konfiguriere diese Stimme für Deinen Unified Shop.',
        description:
            'Änderungen, die Du hier speicherst, sind nicht sofort in Deinem Shop sichtbar. Stattdessen kannst Du sie zunächst in einer Vorschau-Version prüfen und danach in die Live-Version übernehmen. Mehr dazu findest Du am Ende dieser Seite.',
        sections: {
            slug: {
                title: 'Subdomain',
                'title-single': 'Stimmpfad',
                description: 'Das ist die Subdomain, unter der wir Deinen Shop hosten.',
                'description-single': 'Das ist der URL-Pfad für diese Stimme in Deinem Shop.',
                subdomain: 'Deine Shop-Domain: {{shopHost}}',
                'path-preview': 'Deine Stimm-URL: {{speakerHost}}/{{voiceSlug}}',
                warning:
                    'Diese Einstellung kann nur einmal gesetzt werden. Nachdem Du Deine Subdomain gewählt hast, kannst Du sie nicht mehr ändern – wähle also sorgfältig.',
                readonly: 'Diese Einstellung kann nach dem Speichern nicht mehr geändert werden.',
                'validation-format': 'Nur a-z, 0-9 und - erlaubt. Muss mit einem Buchstaben beginnen.',
                'validation-min-length': 'Mindestens 3 Zeichen'
            },
            displayName: {
                title: 'Anzeigename',
                description:
                    'Der Name, der in Deinem Shop angezeigt wird. Das kann Dein vollständiger Name sein oder jeder andere Name, unter dem Deine Kund:innen Dich erkennen.',
                'unified-title': 'Stimmname',
                'unified-description': 'Der Name dieser Stimme, wie er in Deinem Shop angezeigt wird.'
            },
            voiceDescription: {
                title: 'Stimmbeschreibung',
                description:
                    'Eine kurze Beschreibung Deiner Stimme (max. 300 Zeichen). Wird auf der Website unter Deinem Namen und über dem Stimmvergleichs-Player angezeigt.',
                placeholder: 'e.g. Warm, trustworthy voice — perfect for audiobooks and commercials',
                'placeholder-de': 'z.B. Warme, vertrauenswürdige Stimme — perfekt für Hörbücher und Werbung'
            },
            shopPassword: {
                title: 'Shop-Passwort',
                description:
                    'Optionales Passwort zum Schutz Deines Shops vor unerwünschten Besuchern. Wenn gesetzt, müssen Deine Kunden dieses Passwort eingeben, bevor sie Deinen Shop sehen können. Lösche das Passwort, um den öffentlichen Zugriff zu ermöglichen.',
                'description-set': 'Dein Shop ist aktuell durch ein Passwort geschützt.',
                'description-unset': 'Dein Shop ist aktuell für alle zugänglich.'
            },
            image: {
                title: 'Bild',
                description:
                    'Das Bild von Dir, das wir in Deinem Shop anzeigen sollen. Am besten wirkt es mit transparentem Hintergrund.',
                'current-image': 'Aktuelles Bild',
                'change-image': 'Bild ändern',
                preview: 'Vorschau',
                'drop-or-click': 'Ziehe ein Bild hierher oder klicke, um es auszuwählen',
                'select-image': 'Bild auswählen',
                zoom: 'Zoom'
            },
            video: {
                title: 'Video',
                description:
                    'Ein optionales Video, in dem Du Dich Deinen Kund:innen vorstellst. Format: Quadratisch oder Hochformat.',
                'not-supported': 'Dein Browser unterstützt das Video-Tag nicht.',
                'change-video': 'Video ändern',
                remove: 'Entfernen',
                'drop-or-click': 'Ziehe ein Video hierher oder klicke, um es hochzuladen',
                'max-size': 'Maximale Dateigröße: {{maxSize}} MB',
                'file-too-large': 'Datei ist zu groß. Maximale Größe ist {{maxSize}} MB.',
                'read-error': 'Fehler beim Lesen der Datei'
            },
            'primary-voice': {
                title: 'Primäre Stimme',
                description:
                    'Wähle, welche deiner Stimmen für die Klon-Demo-Generierung verwendet und auf der Website angezeigt wird.'
            },
            audioSamples: {
                title: 'Stimm-Demos',
                description:
                    'Lade natürliche Hörproben hoch und generiere Klon-Stimm-Demos. Gib für die Klon-Stimme denselben Text ein, der in der natürlichen Hörprobe gesprochen wird.',
                'website-heading': 'Website-Hörproben',
                'website-description':
                    'Diese Hörproben werden auf unserer Website angezeigt. Beide Hörproben müssen den unten angezeigten festen Text verwenden.',
                'fixed-text-hint':
                    'Nimm Deine natürliche Stimme mit genau diesem Text auf. Die Klon-Stimme wird ihn automatisch generieren.',
                'shop-heading': 'Speaker-Shop-Hörproben',
                'shop-description':
                    'Diese Hörproben werden in Deinem Speaker-Shop angezeigt. Du kannst einen beliebigen Text für die Klon-Stimme verwenden — achte darauf, dass er zur natürlichen Aufnahme passt.',
                'use-website-samples': 'Dieselben Hörproben wie für die Website verwenden',
                'go-to-website-samples': 'Zu den Website-Hörproben ↓',
                'col-natural': 'Natürliche Stimme',
                'col-clone': 'Klon-Stimme',
                'label-en': 'Englisch',
                'label-de': 'Deutsch',
                'not-supported': 'Dein Browser unterstützt das Audio-Tag nicht.',
                'change-audio': 'Audio ändern',
                remove: 'Entfernen',
                'drop-or-click': 'Ziehe eine Audiodatei hierher oder klicke, um sie hochzuladen',
                'max-size': 'Maximale Dateigröße: {{maxSize}} MB',
                'file-too-large': 'Datei ist zu groß. Maximale Größe ist {{maxSize}} MB.',
                'read-error': 'Fehler beim Lesen der Datei'
            },
            demoText: {
                title: 'Demo-Text',
                description: 'Gib den Text ein, der für die Generierung Deiner Klon-Stimm-Demos verwendet wird.',
                'description-managed': 'Der folgende feste Text wird für Deine Klon-Stimm-Demos verwendet.',
                'label-en': 'Englischer Demo-Text',
                'label-de': 'Deutscher Demo-Text',
                'placeholder-en': 'Englischen Text für Klon-Demo-Generierung eingeben...',
                'placeholder-de': 'Deutschen Text für Klon-Demo-Generierung eingeben...'
            },
            cloneDemos: {
                'voice-select-label': 'Stimme für Klon-Demo-Generierung',
                'voice-link-label': 'Stimme für Website-Eintrag',
                title: 'Klon-Stimm-Demos',
                description: 'Generiere Demos Deiner geklonten Stimme. Diese können jederzeit neu generiert werden.',
                'label-en': 'Englisches Klon-Demo',
                'label-de': 'Deutsches Klon-Demo',
                'choose-source': 'Wähle, wie Du das Klon-Demo bereitstellen möchtest.',
                upload: 'Klon-Demo hochladen',
                generate: 'Generieren',
                regenerate: 'Neu generieren',
                generating: 'Wird generiert...',
                delete: 'Löschen',
                'keep-current': 'Aktuelles behalten',
                replace: 'Ersetzen',
                'replace-generated-title': 'Generiertes Demo ersetzen?',
                'replace-generated-description':
                    'Wenn Du ein Klon-Demo hochlädst, wird die generierte Vorschau verworfen, die noch nicht gespeichert wurde.',
                'replace-upload-title': 'Ausgewählten Upload ersetzen?',
                'replace-upload-description':
                    'Wenn Du ein Klon-Demo generierst, wird der ausgewählte Upload verworfen, der noch nicht gespeichert wurde.',
                'no-voice-data': 'Stimmdaten müssen konfiguriert sein, bevor Klon-Demos generiert werden können.',
                'text-required': 'Bitte gib einen Demo-Text ein, bevor Du generierst.',
                'fixed-demo-text':
                    'Mit CrispyVoice bekommst du professionelle Sprecherstimmen. Flexibel. Rechtssicher. Und genau dann, wann du sie brauchst. KI für schnelle Projekte, die natürliche Stimme für echte Emotion.'
            },
            voiceSettings: {
                title: 'Stimmeinstellungen',
                description: 'Konfiguriere die ElevenLabs-Parameter für die Stimmgenerierung dieser Stimme.',
                speed: 'Geschwindigkeit',
                slower: 'langsamer',
                faster: 'schneller',
                stability: 'Stabilität',
                'more-variable': 'variabler',
                'more-stable': 'stabiler',
                similarity: 'Ähnlichkeit',
                similarityBoost: 'Ähnlichkeitsverstärkung',
                style: 'Stil',
                'style-exaggeration': 'Stilübertreibung',
                none: 'keine',
                exaggerated: 'übersteigert',
                'speaker-boost': 'Sprecher-Boost',
                useSpeakerBoost: 'Sprecherverstärkung',
                low: 'niedrig',
                high: 'hoch',
                'overrides-heading': 'Stimmeinstellungen (pro Generierung)'
            },
            currencies: {
                title: 'Unterstützte Währungen',
                description: 'Wähle aus, welche Währungen Du in Deinem Shop anbieten möchtest',
                'select-at-least-one': 'Bitte wähle mindestens eine Währung aus',
                'missing-prices':
                    'Fehlende Preise für: {{currencies}}. Alle unterstützten Währungen benötigen einen Preis.',
                'cannot-activate':
                    '{{currency}} kann nicht aktiviert werden: {{count}} bestehende Nutzung(en) haben keinen {{currency}}-Preis. Bitte füge zuerst {{currency}}-Preise zu allen Nutzungen hinzu.'
            },
            'speaker-mediums': {
                title: 'Deine Medien',
                description:
                    'Definiere die Medien, die Du anbieten möchtest. Medien beschreiben, wie Deine Stimme verwendet werden kann (z.B. Werbung, Soziale Medien, etc.).',
                add: 'Medium hinzufügen',
                save: 'Speichern',
                saving: 'Speichern...',
                delete: 'Löschen',
                deleting: 'Löschen...',
                'confirm-delete': 'Dieses Medium wirklich löschen?',
                'name-required': 'Name ist erforderlich',
                'icon-required': 'Bitte wähle ein Symbol aus',
                'name-already-exists': 'Ein Medium mit diesem Namen existiert bereits',
                'cannot-delete-in-use':
                    'Dieses Medium wird von einer erlaubten Verwendung verwendet und kann nicht gelöscht werden. Entferne es zuerst aus den erlaubten Verwendungen.',
                'cannot-delete-has-purchases':
                    'Dieses Medium wurde von Kund:innen gekauft und kann nicht gelöscht werden.',
                fields: {
                    name: 'Bezeichner',
                    'name-placeholder': 'z.B. social-media',
                    icon: 'Symbol',
                    'title-en': 'Titel (Englisch)',
                    'title-en-placeholder': 'z.B. Social Media',
                    'title-de': 'Titel (Deutsch)',
                    'title-de-placeholder': 'z.B. Soziale Medien',
                    'examples-en': 'Beispiele (Englisch)',
                    'examples-en-placeholder': 'z.B. Facebook, YouTube, Instagram',
                    'examples-de': 'Beispiele (Deutsch)',
                    'examples-de-placeholder': 'z.B. Facebook, YouTube, Instagram'
                }
            },
            mediums: {
                title: 'Erlaubte Verwendungen',
                description: 'Die Verwendungsarten, aus denen Deine Kund:innen wählen können',
                'manage-mediums-link': 'Verwalte Deine Medien →',
                edit: 'Bearbeiten',
                add: 'Neu hinzufügen',
                save: 'Speichern',
                saving: 'Speichern...',
                delete: 'Löschen',
                deleting: 'Löschen...',
                'base-price-info': '{{prices}} mit {{basePriceCharacters}} enthaltenen Zeichen',
                restricted: 'Beschränkt auf',
                characters: 'Zeichen',
                fields: {
                    medium: {
                        title: 'Medium',
                        placeholder: 'Medium auswählen',
                        explanations: {
                            short: '',
                            long: ''
                        }
                    },
                    'price-chf': {
                        title: 'Preis CHF',
                        placeholder: '',
                        explanations: {
                            short: 'Leer lassen, wenn nicht in CHF angeboten',
                            long: ''
                        }
                    },
                    'price-eur': {
                        title: 'Preis EUR',
                        placeholder: '',
                        explanations: {
                            short: 'Leer lassen, wenn nicht in EUR angeboten',
                            long: ''
                        }
                    },
                    'price-usd': {
                        title: 'Preis USD',
                        placeholder: '',
                        explanations: {
                            short: 'Leer lassen, wenn nicht in USD angeboten',
                            long: ''
                        }
                    },
                    'base-price-characters': {
                        title: 'Zeichen im Grundpreis',
                        placeholder: 'Zeichen',
                        explanations: {
                            short: 'Die im Grundpreis enthaltenen Zeichen',
                            long: 'Zusätzliche Zeichen werden linear abgerechnet'
                        }
                    },
                    'restrict-usage-time': {
                        title: 'Nutzungszeit einschränken',
                        explanations: {
                            short: 'Einschränkung der Nutzung auf einen bestimmten Zeitraum',
                            long: ''
                        }
                    },
                    'timeframe-unit': {
                        title: 'Zeitraum',
                        placeholder: 'Zeitraum auswählen',
                        explanations: {
                            short: 'Der Zeitraum der Beschränkung',
                            long: ''
                        }
                    },
                    'timeframe-value': {
                        title: 'Länge',
                        placeholder: 'Beschränkungsdauer',
                        explanations: {
                            short: 'Der Zeitraum der Beschränkung',
                            long: ''
                        }
                    }
                }
            },
            testimonials: {
                title: 'Testimonials',
                description: 'The testimonials your clients can see',
                edit: 'Edit',
                add: 'Add new',
                delete: 'Delete'
            },
            classifier: {
                title: 'Klassifizierer-Einschränkungen',
                description: 'Einschränkungen für den Klassifizierer',
                add: 'Neue Einschränkung hinzufügen',
                delete: 'Einschränkung löschen',
                save: 'Einschränkung speichern',
                placeholder: 'Einschränkung eingeben...',
                text: 'Text'
            },
            'classifier-test': {
                title: 'Klassifizierer testen',
                description:
                    'Teste deine Klassifizierer-Einschränkungen, indem du einen Text eingibst, um zu sehen, ob er erlaubt oder blockiert wird.',
                placeholder: 'Text zum Testen eingeben...',
                button: 'Text testen',
                result: {
                    allowed: '✅ ERLAUBT',
                    blocked: '❌ BLOCKIERT',
                    confidence: 'Vertrauensniveau:',
                    'triggered-by': 'Blockiert durch Einschränkung:',
                    'no-restrictions':
                        'Keine Einschränkungen konfiguriert. Füge oben Einschränkungen hinzu, um einen Test durchzuführen.'
                }
            },

            imprint: {
                title: 'Impressum',
                description: 'Das Impressum Deines Shops. In vielen Ländern gesetzlich vorgeschrieben.',
                'missing-link': 'Richte Dein Impressum in den Sprecher-Einstellungen ein →',
                'privacy-mode': {
                    title: 'Datenschutz-Modus',
                    description:
                        'Verbirg Deinen echten Namen und Deine Adresse vor Nicht-Kunden. Wenn aktiviert, wird nur das CrispyVoice-Plattform-Impressum in Deinem Shop angezeigt. Deine persönlichen Daten erscheinen nur im Freigabedokument für zahlende Kunden.',
                    'active-notice':
                        'Datenschutz-Modus ist aktiv — Dein Name und Deine Adresse sind auf der öffentlichen Shop-Seite verborgen.'
                },
                'privacy-active-title': 'Datenschutz-Modus ist aktiv',
                'privacy-active-description':
                    'Dein Name und Deine Adresse werden nur im Freigabedokument angezeigt, das Kunden nach dem Kauf erhalten. Sie erscheinen nirgendwo in Deinem öffentlichen Shop.',
                'privacy-hint':
                    'Du möchtest anonym bleiben? Du kannst den Datenschutz-Modus oben aktivieren, um Deine Identität vor Nicht-Kunden zu verbergen.',
                address: {
                    'legal-name': 'Rechtlicher Name',
                    street: 'Straße',
                    zipcode: 'Postleitzahl',
                    city: 'Stadt',
                    country: 'Land'
                }
            },
            links: {
                title: 'Links',
                description:
                    'Links zu Deinen Social-Media-Profilen, Deiner Website usw. Diese werden in Deinem Shop angezeigt.',
                add: 'Neuen Link hinzufügen',
                delete: 'Link löschen',
                save: 'Link speichern',
                url: 'URL',
                type: {
                    xing: 'Xing',
                    'linked-in': 'LinkedIn',
                    facebook: 'Facebook',
                    instagram: 'Instagram',
                    homepage: 'Homepage',
                    youtube: 'YouTube',
                    tiktok: 'TikTok',
                    other: 'Andere'
                }
            },
            'preview-shop': {
                title: 'Shop-Vorschau & Veröffentlichung',
                description: 'Die Shop-Vorschau ist nur für Dich sichtbar.',
                open: 'Shop-Vorschau öffnen',
                'missing-data-description':
                    'Folgende Informationen fehlen noch, bevor wir Deinen Shop erstellen können. Bitte fülle die entsprechenden Abschnitte oben aus und vergiss nicht, auf „Speichern“ zu klicken.',
                'clone-not-ready':
                    'Super! Du hast alle relevanten Informationen für den Shop bereitgestellt. Es fehlt nur noch der Klon Deiner Stimme, um Deinen Live-Shop zu erstellen.',
                'unreleased-changes': 'Du kannst Deine vorgenommenen Änderungen hier in der Shop-Vorschau ansehen:',
                'no-unreleased-changes':
                    'Es scheint, als hättest Du bereits alle Änderungen im Live-Shop veröffentlicht. Gut gemacht!',
                release: {
                    description:
                        'Wenn Du mit den vorgenommenen Änderungen zufrieden bist, kannst Du sie mit folgendem Button in die Live-Version Deines Shops übernehmen:',
                    button: 'Änderungen im Live-Shop veröffentlichen'
                },
                'live-shop-description': 'Hier kannst Du auch Deinen aktuellen Live-Shop öffnen:',
                'show-live-shop': 'Live-Shop öffnen'
            },
            'shop-status': {
                title: 'Dein Shop',
                description:
                    'Dein Shop wird automatisch veröffentlicht, sobald alle erforderlichen Informationen ausgefüllt sind. Änderungen sind sofort sichtbar.',
                live: 'Dein Shop ist live! Änderungen, die Du speicherst, sind sofort sichtbar.',
                'open-shop': 'Deinen Shop öffnen',
                'not-live-yet':
                    'Dein Shop ist noch nicht live. Fülle die erforderlichen Einstellungen unten aus, um ihn automatisch zu veröffentlichen.',
                'not-live-voice-id-missing':
                    'Dein Shop ist noch nicht live. Wir arbeiten noch an Deinem Stimmklon. Sobald die Produktion abgeschlossen ist, wird Dein Shop automatisch veröffentlicht.',
                'missing-data': 'Folgende Informationen fehlen noch:'
            }
        },
        'already-in-use': 'Dieser Slug ist bereits vergeben',
        'subdomain-reserved': 'Diese Subdomain ist reserviert und kann nicht verwendet werden',
        save: 'Speichern',
        saving: 'Speichern...',
        'save-successful': 'Änderungen erfolgreich gespeichert',
        'form-dirty': 'Du hast ungespeicherte Änderungen',
        required: 'Erforderlich',
        'required-settings-heading': 'Pflichteinstellungen',
        'optional-settings-heading': 'Optionale Einstellungen',
        'website-settings-heading': 'Website — Sprecher:innen-Seite',
        'website-settings-propagation-note':
            'Änderungen hier können bis zu 5 Minuten dauern, bis sie auf der Website sichtbar sind.',
        'website-prerequisites-met-en': 'Deine Stimme wird auf der <0>englischen Website</0> angezeigt.',
        'website-prerequisites-met-de': 'Deine Stimme wird auf der <0>deutschen Website</0> angezeigt.',
        'website-prerequisites-not-met-en':
            'Deine Stimme wird nicht auf der <0>englischen Website</0> angezeigt. Es fehlt:',
        'website-prerequisites-not-met-de':
            'Deine Stimme wird nicht auf der <0>deutschen Website</0> angezeigt. Es fehlt:',
        'website-prerequisites-description-en': 'Stimmbeschreibung (English)',
        'website-prerequisites-description-de': 'Stimmbeschreibung (Deutsch)',
        'website-prerequisites-sample-en': 'Website-Hörprobe (English)',
        'website-prerequisites-sample-de': 'Website-Hörprobe (Deutsch)',
        countries: shopSettingsCountries
    },
    buyers: {
        heading: 'Käufer',
        'no-buyers': 'Du hast noch keine Käufer.',
        'no-buyers-description':
            'Bewirb deine CrispyVoice und verkaufe sie an deine Fans! Sobald du Verkäufe hast, werden ihre Käufer hier angezeigt.',
        'buyer-name': 'Name',
        'buyer-email': 'Email',
        'buyer-phoneNumber': 'Telefonnummer',
        'buyer-city': 'Stadt',
        'buyer-number-of-sales': 'Anzahl der Verkäufe',
        'buyer-total-sales-volume': 'Gesamtumsatz',
        details: {
            heading: 'Kunde: {{buyerName}}'
        }
    },
    sales: {
        heading: 'Verkäufe',
        'no-sales': 'Du hast noch keine Verkäufe.',
        'no-sales-description':
            'Bewirb deine CrispyVoice und verkaufe sie an deine Fans! Sobald du Verkäufe hast, werden sie hier angezeigt.',
        details: {
            heading: 'Verkauf: {{buyerName}} / {{date}}'
        }
    },
    onboarding: {
        emails: {
            welcome: {
                subject: 'Willkommen bei CrispyVoice 🚀',
                heading: 'Willkommen an Bord {{user_name}}!',
                login: 'Hier einloggen',
                intro:
                    'Danke Dir fuer Dein Vertrauen. Wir freuen uns darauf, Dir dabei zu helfen, in einer KI-getriebenen Welt konkurrenzfaehig zu bleiben.',
                uploadPrefix: 'Die Audiodaten fuer Deinen Stimmklon kannst Du hier hochladen:',
                uploadLinkLabel: 'Klick',
                uploadSuffix: 'Vergiss nicht, Deine hochgeladenen Audiodaten danach auch zu bestaetigen.',
                stepsHeading: 'Der weitere Kurs ist klar:',
                stepUpload: 'Audiodateien hochladen',
                stepRelax: 'Zuruecklehnen und entspannen',
                stepStatus:
                    'Wir melden uns, sobald Dein Klon seeklar ist. Den aktuellen Status kannst Du jederzeit in Deinem Account checken.',
                documentsHeading: 'Wichtige Dokumente findest Du unter den folgenden Links:',
                invoiceLinkLabel: 'Deine Rechnung',
                termsLinkLabel: 'Unsere AGB',
                privacyLinkLabel: 'Datenschutzerklaerung',
                credentialsNotice:
                    'Deine Login-Daten hast Du bereits in einer separaten Mail erhalten - denk daran, das Passwort zu aendern.',
                support:
                    'Falls Du waehrend der Reise Unterstuetzung brauchst, sind wir immer in Rufweite. Schreib uns einfach eine Mail oder ruf uns an.',
                signoff: 'Ahoi und viele Gruesse aus der Schweiz',
                team: 'Dein CrispyVoice-Team'
            },
            password: {
                subject: 'CrispyVoice: Deine Login-Daten 🔐',
                heading: 'CrispyVoice Account-Password',
                'password-text': 'Hier ist dein initiales Account-Passwort:',
                login: 'Hier einloggen',
                'change-it': 'Bitte aendere Dein Passwort nach dem ersten Login.',
                greeting: 'Ahoi!',
                credentialsIntro: 'Hier sind Deine Zugangsdaten fuer Deinen CrispyVoice-Account:',
                usernameLabel: 'Benutzername:',
                initialPasswordLabel: 'Initiales Passwort:',
                importantHeading: 'Wichtig:',
                loginPrefix: 'Login hier:',
                helpHeading: 'Brauchst Du Hilfe?',
                helpPrefix: 'Schau in unsere',
                helpLinkLabel: 'FAQ',
                helpSuffix: 'oder kontaktiere unsere Crew direkt.',
                signoff: 'Ahoi aus der Schweiz',
                team: 'Dein CrispyVoice-Team'
            },
            newSpeakerRegistration: {
                subject: 'Ein neuer Sprecher hat sich gerade registriert!'
            }
        }
    },
    affiliate: {
        heading: 'CrispyAffiliate',
        description: 'Verdiene Provisionen von Sprechern, die sich über deinen persönlichen Affiliate-Link anmelden.',
        'your-link': 'Dein Affiliate-Link',
        'copy-link': 'Link kopieren',
        'link-copied': 'Kopiert!',
        'your-terms': 'Deine Provisionsbedingungen',
        'no-touch-heading': 'No-Touch-Verkauf',
        'assisted-heading': 'Begleiteter Verkauf',
        'sale-rate': 'Verkaufsprovision',
        'sale-duration': 'Verkaufsdauer',
        'monthly-fee-rate': 'Monatliche Gebührenprovision',
        'monthly-fee-duration': 'Gebührendauer',
        months: 'Monate',
        unlimited: 'unbegrenzt',
        rate: 'Satz',
        'no-touch-rate': 'No-Touch-Satz',
        'assisted-rate': 'Begleiteter Satz',
        duration: 'Laufzeit',
        'referrals-heading': 'Empfohlene Sprecher',
        'no-referrals': 'Noch keine Empfehlungen. Teile deinen Affiliate-Link, um zu verdienen!',
        'sale-type-heading': 'Provisionsart',
        'sale-type-self-service': 'Aktive Vermarktung',
        'sale-type-assisted': 'Basis-Empfehlung',
        'sale-type-pending': 'In Prüfung',
        'sale-type-self-service-tooltip':
            'Du hast aktiv mit dieser Person zusammengearbeitet – wir mussten kein Gespräch führen.',
        'sale-type-assisted-tooltip':
            'Diese Person hat sich über deinen Link angemeldet und wir haben ein Gespräch geführt.',
        'sale-type-pending-tooltip':
            'Die Provisionsart wurde noch nicht festgelegt. Der Umsatz wird erst nach Festlegung berücksichtigt.',
        'pending-classification': 'in Prüfung',
        'pending-note':
            '{{count}} Empfehlung(en) werden noch geprüft. Deren Umsatz ist in den obigen Summen nicht enthalten, bis die Provisionsart festgelegt wurde.',
        'cv-sales-revenue': 'CrispyVoice-Verkaufsumsatz',
        'sales-commission': 'Verkaufsprovision',
        'monthly-fee-commission': 'Monatliche Gebührenprovision',
        'total-commission': 'Gesamtprovision',
        'transfer-desc-audio-sale': 'Provision – Audioverkauf von {{name}} ({{percent}}%)',
        'transfer-desc-subscription': 'Provision – Abonnement von {{name}} ({{percent}}%)',
        'contract-type': 'Vertragstyp',
        status: 'Status',
        'status-active': 'Aktiv',
        'status-past_due': 'Überfällig',
        'status-canceled': 'Gekündigt',
        'status-unknown': 'Unbekannt',
        'signed-up': 'Angemeldet',
        total: 'Gesamt',
        'bonus-heading': 'Meilenstein-Boni',
        'bonus-description':
            'Verdiene einmalige Boni, indem du Empfehlungs-Meilensteine erreichst. Qualifizierte Empfehlungen: Core-/Basic-Accounts mit jährlicher Zahlung und aktivem Abonnement.',
        'bonus-qualifying-count': 'Qualifizierte Empfehlungen',
        'bonus-referrals': 'Empfehlungen',
        'bonus-total-earned': 'Verdiente Meilenstein-Boni',
        'campaigns-heading': 'Botschafter-Kampagnen',
        'campaign-label': 'Kampagne:',
        'campaign-codes-left': '{{count}} Codes übrig',
        'campaign-no-codes': 'Keine ungenutzten Einladungscodes',
        'campaign-copy-code': 'Klicken, um Link zu kopieren',
        'campaign-discount': 'Rabatt',
        'campaign-redeemed': '{{count}} eingelöst',
        'campaign-outstanding': '{{count}} ausstehend',
        'campaign-remaining': '{{count}} verbleibend',
        'campaign-all-redeemed': 'Alle Einladungscodes wurden eingelöst.',
        'campaign-get-next': 'Nächsten Einladungslink kopieren ({{remaining}} übrig)',
        'campaign-link-copied': 'Link kopiert!',
        'campaign-loading': 'Link wird geladen...',
        'campaign-show-history': 'Gesendete Links anzeigen ({{count}})',
        'campaign-hide-history': 'Gesendete Links ausblenden',
        'campaign-status-redeemed': 'Eingelöst',
        'campaign-status-open': 'Offen',
        'campaign-status-invalidated': 'Ungültig'
    },
    voices: {
        heading: 'Meine Stimmen',
        description:
            'Verwalte deine Stimmklone. Jede Stimme kann einen eigenen Shop, Aufnahmen und Einstellungen haben.',
        'voice-count': '{{count}} von {{max}} Stimmen',
        'add-voice': 'Stimme hinzufügen',
        'voice-label': 'Stimme {{index}}',
        'status-ready': 'Bereit',
        'status-pending': 'Ausstehend',
        'status-archived': 'Archiviert',
        delete: 'Löschen',
        archive: 'Archivieren',
        unarchive: 'Wiederherstellen',
        'archived-heading': 'Archivierte Stimmen',
        'set-voice-id': 'Voice ID festlegen',
        'change-voice-id': 'Voice ID ändern',
        'col-name': 'Name',
        'col-slug': 'Slug',
        'col-voice-id': 'Voice ID',
        'col-status': 'Status',
        'create-modal': {
            title: 'Neue Stimme hinzufügen',
            'name-label': 'Stimmname',
            'name-placeholder': 'z.B. Meine Deutsche Stimme',
            'copy-from-label': 'Einstellungen kopieren von',
            'copy-from-none': 'Neu beginnen',
            'copy-from-description':
                'Kopiert Preise, Links, Einschränkungen und Testimonials von der ausgewählten Stimme.',
            'voice-id-label': 'ElevenLabs Voice ID',
            'voice-id-description': 'Optional: Setze die ElevenLabs Voice ID jetzt oder füge sie später hinzu.',
            submit: 'Stimme erstellen'
        },
        'delete-modal': {
            title: 'Stimme löschen',
            description:
                'Möchtest du diese Stimme wirklich löschen? Alle zugehörigen Aufnahmen und Shop-Daten werden dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
            confirm: 'Stimme löschen'
        },
        'archive-modal': {
            title: 'Stimme archivieren',
            description:
                'Durch das Archivieren dieser Stimme wird der Shop deaktiviert. Die Stimme und ihre verkauften Aufnahmen bleiben erhalten, sind aber nicht mehr öffentlich verfügbar. Archivierte Stimmen zählen nicht zum Stimmen-Limit.',
            confirm: 'Stimme archivieren'
        },
        'voice-id-modal': {
            title: 'ElevenLabs Voice ID festlegen',
            label: 'ElevenLabs Voice ID',
            placeholder: 'z.B. bqnMEfPMfAsV6leYpGPD',
            description:
                'Gib die Voice ID aus deinem ElevenLabs-Konto ein. Du findest sie in den ElevenLabs-Stimmeinstellungen.',
            submit: 'Voice ID speichern'
        },
        'test-voice': {
            label: 'Stimme testen',
            placeholder: 'Text zum Testen eingeben (max. 100 Zeichen)',
            test: 'Testen',
            testing: 'Teste…'
        }
    },
    'speaker-settings': {
        heading: 'Sprecher-Einstellungen',
        subheading: 'Verwalte Deine globalen Sprecher-Einstellungen. Diese gelten für alle Deine Stimmen.',
        sections: {
            'speaker-mediums': {
                title: 'Deine Medien',
                description:
                    'Definiere die Medien, die Du anbieten möchtest. Medien beschreiben, wie Deine Stimme verwendet werden kann (z.B. Werbung, Soziale Medien, etc.).',
                'name-required': 'Name ist erforderlich',
                'icon-required': 'Bitte wähle ein Symbol aus',
                'name-already-exists': 'Ein Medium mit diesem Namen existiert bereits',
                'cannot-delete-in-use':
                    'Dieses Medium wird von einer erlaubten Verwendung verwendet und kann nicht gelöscht werden. Entferne es zuerst aus den erlaubten Verwendungen.',
                'cannot-delete-has-purchases':
                    'Dieses Medium wurde von Kund:innen gekauft und kann nicht gelöscht werden.'
            },
            'shop-mode': {
                title: 'Shop-Modus',
                description:
                    'In welcher Beziehung stehen Deine Stimmen zueinander? Diese Einstellung ist dauerhaft und kann später nicht geändert werden.',
                'locked-title': 'Shop-Modus ist konfiguriert',
                'current-single':
                    'Dein Shop ist konfiguriert für eine Person mit mehreren Stimmstilen und ist verfügbar unter:',
                'current-separate': 'Dein Shop ist konfiguriert für mehrere Personen oder Personas.',
                'separate-title': 'Mehrere Personen / Personas',
                'separate-description':
                    'Wähle dies, wenn Deine Stimmen verschiedene Personen oder völlig unterschiedliche Personas darstellen. Jede Stimme bekommt eine eigene Subdomain (z.B. stimmen-name.crispyvoice.com).',
                'single-title': 'Eine Person, mehrere Stile',
                'single-description':
                    'Wähle dies, wenn eine Person mehrere Stimmstile anbietet (z.B. sachlich, begeistert, erzählend). Alle Stimmen werden unter einer Subdomain zusammengefasst (z.B. mein-shop.crispyvoice.com/stimmen-name).',
                'slug-label': 'Shop-Subdomain',
                'slug-placeholder': 'mein-shop',
                'slug-preview': 'Dein Shop wird unter {{shopHost}} erreichbar sein',
                'slug-min-length': 'Muss mindestens 3 Zeichen lang sein',
                'slug-format':
                    'Muss mit einem Buchstaben beginnen und darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten',
                'slug-required': 'Ein Subdomain-Slug ist für den Einzelne-Subdomain-Modus erforderlich',
                'slug-taken': 'Dieser Slug ist bereits vergeben',
                'slug-reserved': 'Diese Subdomain ist reserviert und kann nicht verwendet werden',
                'already-configured': 'Der Shop-Modus wurde bereits konfiguriert und kann nicht geändert werden',
                'lock-warning':
                    'Achtung: Diese Einstellung ist dauerhaft. Nach dem Speichern kann nicht zwischen den Modi gewechselt werden.',
                save: 'Shop-Modus speichern',
                'display-name-title': 'Anzeigename',
                'display-name-description': 'Der Name, der öffentlich in Deinem Shop angezeigt wird.',
                'display-name-placeholder': 'Dein Name oder Deine Marke',
                'display-name-required': 'Anzeigename ist erforderlich'
            },
            'unified-shop': {
                title: 'Einzelseiten-Shop (Beta)',
                description:
                    'Statt der Stimmen-Übersicht wird eine einzelne Shop-Seite mit Voicing-Auswahl und direktem Checkout für alle Deine Stimmen angezeigt. Bei Aktivierung wird die Stimm-URL-Einstellung (Sub-Pfad) in den Shop-Einstellungen ausgeblendet.',
                enabled: 'Einzelseiten-Shop aktiv',
                disabled: 'Einzelseiten-Shop inaktiv'
            },
            'shared-shop': {
                'select-at-least-one-currency': 'Wähle mindestens eine Währung aus.'
            },
            'shop-description': {
                title: 'Shop-Beschreibung',
                description:
                    'Beschreibe Dein Stimmangebot für den Unified Shop. Dieser Text ist unabhängig von Deinem Website-Profil.',
                english: 'Englisch',
                german: 'Deutsch',
                save: 'Beschreibung speichern',
                saved: 'Beschreibung gespeichert',
                unsaved: 'Du hast ungespeicherte Änderungen.'
            },
            imprint: {
                title: 'Impressum',
                description: 'Das Impressum Deines Shops. In vielen Ländern gesetzlich vorgeschrieben.',
                'privacy-mode': {
                    title: 'Datenschutz-Modus',
                    description:
                        'Verbirg Deinen echten Namen und Deine Adresse vor Nicht-Kunden. Wenn aktiviert, wird nur das CrispyVoice-Plattform-Impressum in Deinem Shop angezeigt. Deine persönlichen Daten erscheinen nur im Freigabedokument für zahlende Kunden.',
                    'active-notice':
                        'Datenschutz-Modus ist aktiv — Dein Name und Deine Adresse sind auf der öffentlichen Shop-Seite verborgen.'
                },
                'privacy-active-title': 'Datenschutz-Modus ist aktiv',
                'privacy-active-description':
                    'Dein Name und Deine Adresse werden nur im Freigabedokument angezeigt, das Kunden nach dem Kauf erhalten. Sie erscheinen nirgendwo in Deinem öffentlichen Shop.',
                'privacy-hint':
                    'Du möchtest anonym bleiben? Du kannst den Datenschutz-Modus oben aktivieren, um Deine Identität vor Nicht-Kunden zu verbergen.',
                address: {
                    'legal-name': 'Rechtlicher Name',
                    street: 'Straße',
                    zipcode: 'Postleitzahl',
                    city: 'Stadt',
                    country: 'Land'
                }
            }
        },
        save: 'Speichern',
        'save-successful': 'Änderungen erfolgreich gespeichert',
        'form-dirty': 'Du hast ungespeicherte Änderungen'
    }
};
